import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getChatChannels,
  getChatHasUnreadMessages,
} from 'app/store/Chat/selectors';
import { useEffect } from 'react';
import {
  fetchChatChannelsEffect,
  fetchChatUnreadCountEffect,
} from 'app/store/Chat/effects';
import { useResource } from 'app/utils/hooks';
import { ChatChannelListItem } from 'types/chat.types';
import { updateChannelsListOpen } from 'app/store/Chat/slice';
import { routes } from 'app/routing/routesConfig';
import { useLocation } from 'react-router-dom';

export const useFetchChannelsList = (
  props: { checkPathname: boolean } | void
) => {
  const dispatch = useAppDispatch();
  const checkPathname = props?.checkPathname;
  const { pathname } = useLocation();
  const hasUnread = useAppSelector(getChatHasUnreadMessages);
  const [channels, loading] = useResource<ChatChannelListItem[]>(
    fetchChatChannelsEffect,
    getChatChannels,
    { useCache: false }
  );

  useEffect(() => {
    dispatch(fetchChatChannelsEffect());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading && !hasUnread) {
      dispatch(fetchChatChannelsEffect());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasUnread]);

  useEffect(() => {
    dispatch(fetchChatUnreadCountEffect());
  }, [dispatch]);

  useEffect(() => {
    dispatch(updateChannelsListOpen(true));

    return () => {
      const updateState = checkPathname
        ? pathname !== routes.messages.path
        : true;
      if (updateState) {
        dispatch(updateChannelsListOpen(false));
      }
    };
  }, [dispatch, pathname, checkPathname]);

  return {
    channels,
    loading,
  };
};
